import { Nav, NavItem, NavLink } from "reactstrap";
import { SimpleNavProps } from "../../../../Types/UiKitsType";

const PillNav: React.FC<SimpleNavProps> = ({ basicTab, setBasicTab }) => {
  return (
    <Nav tabs>
      <NavItem>
        <NavLink
          href={"#"}
          className={basicTab === "1" ? "active" : ""}
          onClick={() => setBasicTab("1")}
        >
          <i className="fa fa-briefcase me-2"></i>Job Titles
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          href={"#"}
          className={basicTab === "2" ? "active" : ""}
          onClick={() => setBasicTab("2")}
        >
          <i className="fa fa-cogs me-2"></i>Job Title Maintenance
        </NavLink>
      </NavItem>
    </Nav>
  );
};
export default PillNav;
